import React, { useEffect } from 'react';
import { array, object } from 'prop-types';
import { Switch } from 'react-router-dom';

import { connect } from 'react-redux';

import ManagementPage from './Management/ManagementPage';
import SettingsPage from './Settings/SettingsPage';

import ProtectedRoute from '../../components/ProtectedRoute';

import * as CoreActions from '../../actions/coreActions';
import * as ServiceManagementActions from '../../actions/serviceManagementActions';

import classes from './ServiceManagement.module.css';

const ServiceManagement = ({
    companyInfo,
    currentScopes,
    fetchAlias,
    fetchAppointmentStatuses,
    fetchCallPriorities,
    fetchInitialSMClients,
    fetchIssueTypes,
    fetchServiceItemList,
    fetchSMRules,
    fetchStatuses,
    fetchTechniciansList,
    resetActiveItem,
    setProgressBarLoading,
    ...props
}) => {
    useEffect(() => {
        return () => {
            resetActiveItem();
        };
    }, []);

    useEffect(() => {
        async function init() {
            const { companyId } = companyInfo;

            resetActiveItem();

            setProgressBarLoading(true);

            // Due to a race condition within the Promise.all we are allowing
            // these calls to be made first:
            await fetchTechniciansList();
            await fetchAppointmentStatuses();

            Promise.all([
                fetchAlias(),
                fetchCallPriorities(),
                fetchStatuses(),
                fetchInitialSMClients(companyId),
                fetchIssueTypes(),
                fetchSMRules(companyId)
            ].map(p => p.catch(err => err))).then(() => {
                setProgressBarLoading(false);
            });
        }

        init();
    }, [companyInfo.companyId]);

    if (!currentScopes) {
        return null;
    }

    return (
        <div className={classes.ServiceManagement}>
            <Switch>
                <ProtectedRoute
                    component={SettingsPage}
                    path="/servicemanagement/settings/"
                    permissions="serviceManagementFull"
                />
                <ProtectedRoute
                    component={ManagementPage}
                    path="/servicemanagement"
                    permissions="serviceManagementRead"
                />
            </Switch>
        </div>
    );
};

ServiceManagement.defaultProps = {
    companyInfo:   {},
    currentScopes: []
};

ServiceManagement.propTypes = {
    companyInfo:   object,
    currentScopes: array
};

const mapStateToProps = state => {
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceManagement);
